/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Hide_Scheduled_Trips_LabelInputs */

const fr_settings_hide_scheduled_trips_label = /** @type {(inputs: Settings_Hide_Scheduled_Trips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer les courses théoriques`)
};

const en_settings_hide_scheduled_trips_label = /** @type {(inputs: Settings_Hide_Scheduled_Trips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide scheduled trips`)
};

/**
* | output |
* | --- |
* | "Hide scheduled trips" |
*
* @param {Settings_Hide_Scheduled_Trips_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_hide_scheduled_trips_label = /** @type {((inputs?: Settings_Hide_Scheduled_Trips_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Hide_Scheduled_Trips_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_hide_scheduled_trips_label(inputs)
	return en_settings_hide_scheduled_trips_label(inputs)
});